export default __webpack_public_path__ + "static/media/Nani.57b58f8d.mp3";